import { useState, useCallback, useEffect } from 'react';
import Modal from 'react-modal';
import './styles.scss';
import dayjs from 'dayjs';
import { postScheduleService } from '../../../../../services/scheduling';
import { isResponseOk } from '../../../../../utility/isResponseOk';
import { toast } from 'react-toastify';

const PostScheduleModal = ({ periodData, closeModal, setPeriodData }) => {
  const postSchedule = useCallback(async () => {
    try {
      const response = await postScheduleService(periodData.id);
      if (isResponseOk(response)) {
        closeModal();
        setPeriodData((prevState) => ({ ...prevState, is_published: true }));
        toast.success('The schedule was successfully posted', { hideProgressBar: false });
      }
    } catch (e) {
      console.error(e);
    }
  }, [periodData, setPeriodData]);

  const handleConfirm = () => {
    postSchedule();
  };

  return (
    <Modal
      className="modal-alert post-schedule-modal"
      isOpen
      onRequestClose={closeModal}
      contentLabel="Post Schedule modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="5" width="38" height="38" rx="19" fill="#F4EBFF" />
            <rect x="5" y="5" width="38" height="38" rx="19" stroke="#F9F5FF" strokeWidth="10" />
            <path
              d="M19.6365 17.4531H30.7637C30.8988 17.4531 31.0283 17.5106 31.1237 17.6129C31.2192 17.7152 31.2728 17.8539 31.2728 17.9986V27.6349"
              stroke="#7F56D9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.1819 26.0423V20.8918C18.1819 20.7526 18.2328 20.6192 18.3236 20.5208C18.4143 20.4225 18.5373 20.3672 18.6656 20.3672H27.88C28.0083 20.3672 28.1313 20.4225 28.222 20.5208C28.3127 20.6192 28.3637 20.7526 28.3637 20.8918V30.0244C28.3637 30.1635 28.3127 30.297 28.222 30.3954C28.1313 30.4937 28.0083 30.549 27.88 30.549H23.0191"
              stroke="#7F56D9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.2727 26.9062L18.9091 30.5426L16.7273 28.7244"
              stroke="#7F56D9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span className="modal-header-title">Post Schedule</span>
        </div>
        <button className="btn btn-icon" onClick={closeModal}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div className="modal-inner-info">
        <p>Are you sure you want to make this schedule visible for employees?</p>

        <div className="schedule-date-wrapper">
          <span className="schedule-date-title">
            {dayjs(periodData.start_date).format('MMMM D, YYYY')} – {dayjs(periodData.end_date).format('MMMM D, YYYY')}
          </span>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-outline" onClick={closeModal}>
          Cancel
        </button>
        <button
          className="btn"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default PostScheduleModal;
